import { C, P0, R, S, abs, core, disc, moodK } from '../../geometry';

export const swirl = {
  name: 'Swirl',
  colors: ['#8E4EC6', '#1FA2D6'],
  draw(m, t) {
    let rmax = 38,
      turns = 1.15,
      sc = 1,
      spin = 12 * S(t * 0.5),
      pose = P0();
    if (m === 'happy') {
      spin = 30 * S(t * 5);
      rmax = 40 + 2 * abs(S(t * 7));
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: the spiral keeps winding round.
    if (m === 'thinking') spin = t * 110;
    if (m === 'talking') sc = 1 + 0.06 * S(t * 10);
    if (m === 'surprised') {
      rmax = 43;
      turns = 0.9;
    }
    if (m === 'paused') {
      rmax = 30;
      turns = 1.4;
      spin = 3 * S(t * 0.5);
    }
    const pts = [...Array(26)].map((_, k) => {
      const f = k / 25,
        a = (-90 + f * turns * 360) * R,
        r = (18 + f * (rmax - 18)) * sc;
      return [50 + r * C(a), 52 + r * S(a)];
    });
    return {
      strokes: [
        { c: 'a', pts, n: 32, spin },
        { c: 'b', pts: [pts[25], [pts[25][0] + 0.01, pts[25][1]]], spin },
      ],
      eyes: { x: 50, y: 52 },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f, m, t) {
    f.strokes.unshift(core(disc(50, 52, 11.5 * moodK(m, t))));
    return f;
  },
};
